import React from 'react';
import { LinkOutlined } from '@ant-design/icons';
import type { IInfaktInvoiceLinkProps } from 'components/invoices/infakt-invoice-link/types';

export const InfaktInvoiceLink: React.FC<IInfaktInvoiceLinkProps> = (props) => {
  const { infaktSync } = props;

  if (infaktSync?.status !== 'synced' || !infaktSync.infaktUuid) return null;

  const href = `${import.meta.env.VITE_INFAKT_BASE_URL}/faktura/vat/${infaktSync.infaktUuid}`;

  return (
    <a href={href} target='_blank'>
      <LinkOutlined />
    </a>
  );
};
